<section id="centralgasIndustrial" class="section-wrap industrial-selector" aria-labelledby="industrial-selector-heading">
  <div class="container-fluid">
    <header class="industrial-selector-header">
      <p class="industrial-selector-eyebrow">CENTRALGAS INDUSTRIAL</p>
      <h2 id="industrial-selector-heading">Soluciones para cada necesidad industrial</h2>
      <p class="industrial-selector-intro">
        Acompañamos a profesionales y organizaciones con instalaciones de gas eficientes, seguras y a medida,
        para que su actividad nunca se detenga.
      </p>
    </header>

    <div class="industrial-selector-layout">
      <div class="industrial-sector-mobile">
        <label for="industrial-sector-select">Sector industrial</label>
        <select
          #sectorSelect
          id="industrial-sector-select"
          name="industrial-sector"
          class="industrial-sector-select"
          [value]="activeIndex()"
          aria-controls="industrial-selector-detail"
          (change)="selectSector(sectorSelect.selectedIndex)"
        >
          @for (sector of sectors; track sector.id; let index = $index) {
            <option [value]="index" [disabled]="isTransitioning() && activeIndex() !== index">{{ sector.name }}</option>
          }
        </select>
      </div>

      <nav class="industrial-sector-nav" aria-label="Sectores industriales">
        <ol>
          @for (sector of sectors; track sector.id; let index = $index) {
            <li>
              <button
                type="button"
                class="industrial-sector-button"
                [class.is-active]="activeIndex() === index"
                [attr.aria-pressed]="activeIndex() === index"
                aria-controls="industrial-selector-detail"
                (click)="selectSector(index)"
              >
                <span class="industrial-sector-number">{{ sector.id }}</span>
                <span class="industrial-sector-divider" aria-hidden="true"></span>
                <svg class="industrial-sector-icon" viewBox="0 0 24 24" aria-hidden="true">
                  <path [attr.d]="sector.iconPath"></path>
                </svg>
                <span class="industrial-sector-divider" aria-hidden="true"></span>
                <span class="industrial-sector-name">{{ sector.name }}</span>
                <svg class="industrial-sector-arrow" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="m9 18 6-6-6-6"></path>
                </svg>
              </button>
            </li>
          }
        </ol>
      </nav>

      @if (displayedSector(); as sector) {
        <article
          id="industrial-selector-detail"
          class="industrial-detail"
          [class.is-transitioning]="isTransitioning()"
          aria-live="polite"
        >
          <div class="industrial-detail-content">
            <div>
              <div class="industrial-detail-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <path [attr.d]="sector.iconPath"></path>
                </svg>
              </div>
              <span class="industrial-detail-accent" aria-hidden="true"></span>
              <h3>{{ sector.title }}</h3>
              <p class="industrial-detail-subtitle">{{ sector.subtitle }}</p>
              <p class="industrial-detail-description">{{ sector.description }}</p>
              <ul class="industrial-detail-features" aria-label="Servicios principales">
                @for (feature of sector.features; track $index) {
                  <li>
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                      <path d="m5 12 4 4L19 6"></path>
                    </svg>
                    <span>{{ feature }}</span>
                  </li>
                }
              </ul>
            </div>

            <a
              class="industrial-detail-cta"
              [routerLink]="['/centralgas-industrial', sector.articleSlug]"
            >
              <span>Ampliar información</span>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M5 12h14m-6-6 6 6-6 6"></path>
              </svg>
            </a>
          </div>

          <figure class="industrial-detail-media">
            <picture>
              <source [srcset]="sector.image" type="image/webp">
              <img
                [src]="sector.fallbackImage"
                [alt]="sector.alt"
                width="720"
                height="900"
                loading="lazy"
                decoding="async"
                fetchpriority="low"
              >
            </picture>
          </figure>
        </article>
      }
    </div>
  </div>
</section>
